<template>
    <b-card title="Summary Report">
        <div class="mt-3">
            <div class="activity-content">
                <p class="title-width">Profile Viewers:</p> 
                <p>{{ rows.profile_viewers }}</p>
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Checked Out:</p> 
                <p>{{ rows.checked_out }}</p>
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Hearts Given:</p> 
                <p>{{ rows.heart_given }}</p>
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Hearts Received:</p> 
                <p>{{ rows.heart_received }}</p>
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Matches:</p> 
                <p>{{ rows.matched }}</p>
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Pending Payment:</p> 
                <!-- <p>{{ rows.matched }}</p> -->
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">Completed Payment:</p> 
                <!-- <p>{{ rows.matched }}</p> -->
            </div>
            <div class="activity-content mt-2">
                <p class="title-width">First Activation Date:</p> 
                <p>{{ getActivationDate(rows.first_activation) }}</p>
            </div>
        </div>
    </b-card>
</template>
  
  <script>
  
import {
BAvatar,BButton, BBadge, BPagination, BFormGroup, BFormInput, BFormSelect, BDropdown, BDropdownItem, BCard,
BModal,VBModal,BCardText, BFormTextarea
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import store from '@/store/index'
import vSelect from "vue-select"
import Ripple from "vue-ripple-directive";
import {mapState} from "vuex";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent";

export default {
    components: {
        VueGoodTable,
        BAvatar,
        BCard,
        BBadge,
        BButton,
        BPagination,
        BFormGroup,
        BFormInput,
        BFormSelect,
        BDropdown,
        BDropdownItem,
        BModal,
        vSelect,
        BCardText,
        BFormTextarea
    },

    directives: {
        'b-modal': VBModal,
        Ripple,
    },

    data() {
        return {
            pageLength: 10,
            dir: false,
            columns: [
                {
                    label: '#',
                    field: 'index',
                    type:'number',
                    tdClass: 'text-center ',
                    thClass:'text-center'
                },
                {
                    label: 'Activity',
                    field: 'activity',
                    tdClass: 'text-center',
                    thClass:'text-center'
                }  
            ],
            rows: [],
            searchTerm: '',
        }
    },

    computed: {
        ...mapState('users', ["summary","userError","userLoading"]),
    
        direction() {
            if (store.state.appConfig.isRTL) {
                // eslint-disable-next-line vue/no-side-effects-in-computed-properties
                this.dir = true
                return this.dir
            }
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.dir = false
            return this.dir
        },
    },

    watch: {
        summary(newValue, oldValue) {
            this.rows=this.summary
        }
    },

    created() {
        this.$store.dispatch('users/fetchSummaryByUser', this.$route.params.id)
        this.rows = this.users
        let permissions=JSON.parse(localStorage.getItem('permissions'))
        //   this.showAdd=permissions.includes("add_area")
        //   this.showEdit=permissions.includes("change_area")
        //   this.showDelete=permissions.includes("delete_area")
    },

    methods: {
        getActivationDate(time) {
            return moment(time).format('MMMM Do YYYY, h:mm:ss a')
        }
    }
}
</script>
  
<style lang="scss" scoped>
.no-outline{
    border:none !important;
}

.f20{
    font-size: 8px !important;
}

.vs__dropdown-menu {
  height: 200px;
}

.activity-content {
    font-size: medium;
    display: flex;
    gap: 1rem;
}

.title-width {
    width: 250px;
    font-weight: 600;
}

@media screen and (max-width: 600px) {
    .activity-content {
        font-size: medium;
        display: flex;
        flex-direction: column;
        gap: 2px;
    }
}

@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-good-table.scss';

</style>